module.exports = __webpack_public_path__ + "media/img/careers/why-work/gallery-bg-993b8bbbceaf6a6769f7ba07c76806a1.svg";